import { registerCustomDetailComponent } from "@bb-vendure/admin-ui/core";
import { CorperateDiscountTableComponent } from "./components/cdt.component";

export default [
  registerCustomDetailComponent({
    locationId: "product-detail",
    component: CorperateDiscountTableComponent,
  }),
  // Add your providers here
];
